import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../SmartEvacLogo.jpg";
import NewLogo from '../NewSmartEvacLogo.png';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";

import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AWS = require('aws-sdk');

const client = new S3Client({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: {
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    },
  });

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
});

const params = {
  TableName: "Main_table"
};

const apiURL = 'https://5sz631hba3.execute-api.eu-west-2.amazonaws.com/default/return-recognised-faces';
  
function End() {
  const navigate = useNavigate();
  const location = useLocation();
  const filteredData = location.state?.filteredData; 
  const [imageUrls, setImageUrls] = useState({});

  const EndEvacuation = async (event) => {
    event.preventDefault();
    const removefielddata = {
      removefield: "true"
    }
    const response = await axios.put(apiURL,removefielddata);
    console.log(response);
    navigate('/adminpage');
  };



  useEffect(() => {
    const fetchImageUrls = async () => {
      const urls = {}; 
      for (let item of filteredData) {
        const userId = item.UserID;
        const getObjectParams = {
          Bucket: "facecard-bucket", 
          Key: `${userId}.jpg`,
        };
        const command = new GetObjectCommand(getObjectParams);
        try {
          const url = await getSignedUrl(client, command, { expiresIn: 3600 });
          urls[userId] = url;
        } catch (error) {
          console.error("Error fetching image", error);
        }
      }
      setImageUrls(urls);
    };
    fetchImageUrls();
  });

  return (
    <Container className= "main-page-content">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={6}>
          <img className="napp-logo" src={NewLogo} width="200" height="160" alt="SmartEvac Logo" />
          <h3>Evacuation Ended</h3>
          <h3>Showing emergency contact details of those not found</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Forename</th>
                <th>Surname</th>
                <th>Emergency Name</th>
                <th>Emergency Contact Number</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={index}>
                    <td>{item.fname}</td>
                    <td>{item.sname}</td>
                    <td>{item.emergencyName}</td>
                    <td>{item.emergencyNumber}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={EndEvacuation} type="submit" className="login-button">Return to Home</button>
        </Col>
      </Row>
    </Container>
  );
}

export default End;
